import { jwtDecode } from 'jwt-decode';
import moment from 'moment';
import React, { Fragment, useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { Button, Card, CardBody, Col, Container, Form, FormGroup, Input, Row, Table } from 'reactstrap';
import Breadcrumbs from '../../layout/breadcrumb';
import Loader from '../../layout/loader';
import usePost from '../../hooks/usePost';
import UseGet from '../../hooks/useGet';
import Swal from "sweetalert2"

export default function Bdc() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date())
  const [searchKeyword, setSearchKeyword] = useState("")
  const token = document.cookie.split(`jwt=`).pop().split(';').shift();
  const user_id = token.length > 0 ? jwtDecode(token).id : "";

  const { mutate: getBDC, isLoading: isLoadingGet } = usePost("/bdc/all?user_id=" + user_id, {
    onSuccess: async (fetched) => {
      const final = fetched.map((bdc) => {
        var arraySum = bdc.bdc_products.reduce(function (total, product) {
          var price = parseFloat(product.product_info?.product_price);
          var productTotal = parseInt(product.deliveredQuantity) * price;
          if (isNaN(price) || isNaN(productTotal)) {
            return total + 0
          } else {
            return total + productTotal;
          }
        }, 0);
        arraySum = arraySum.toLocaleString('Fr-DZ', {
          style: 'currency',
          currency: 'DZD'
        });
        return {
          ...bdc,
          total: arraySum
        }
      })
      setData(final);
    },
    onError: (error) => {
      const message = error?.response?.data || "An error occurred!";
      setLoading(false);
      toast.error(error.message);
    }
  });

  const { mutate: getGrossisteList, isLoading } = UseGet('grossite', {
    onSuccess: async (data, variables) => {
      const blob = await data.blob();
      const downloadLink = document.createElement('a');
      const url = window.URL.createObjectURL(blob);
      downloadLink.href = url;
      downloadLink.download = `Bon de commande ${variables.id}.xlsx`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      window.URL.revokeObjectURL(url);
    },
    onError: (error) => {
      const message = error?.response?.data?.message || "An error occurred!";
      toast.error(message);
    },
  });

  const exportDetails = (id) => {
    getGrossisteList(`/bdc/export?bdc_id=${id}`, { id }); // id passed to onSuccess
  };



  // const exportBdcCr = async () => {
  //   const { mutate: getGrossisteList, data: grossisteList, isLoading: isLoadingGet } = UseGet('grossite', `/bdc/extract/ca`, {
  //     onError: (error) => {
  //       const message = error?.response?.data?.message || "An error occurred!";
  //       toast.error(message);
  //     }
  //   });
  //   setLoading(isLoadingGet)
  //   const request = {
  //     method: "POST",
  //     headers: {
  //       "Content-type": "application/json; charset=UTF-8",
  //       "Access-Control-Allow-Origin": "*",
  //       "Access-Control-Allow-Headers": "Origin, X-requested-With, Content-Type, Accept",
  //       'Authorization': 'Bearer ' + token
  //     },
  //     body: JSON.stringify({
  //       start_date: startDate
  //       , end_date: endDate
  //     })
  //   }
  //   try {
  //     var responce = getGrossisteList()
  //     if (responce.status === 200) {
  //       const blob = await responce.blob();
  //       const downloadLink = document.createElement('a');
  //       const url = window.URL.createObjectURL(blob);
  //       downloadLink.href = url;
  //       downloadLink.download = "BDC_par_chiffre_realise.xlsx";
  //       document.body.appendChild(downloadLink);
  //       downloadLink.click();

  //       document.body.removeChild(downloadLink);
  //       window.URL.revokeObjectURL(url);
  //       toast.success("success");

  //     } else {
  //       toast.error(await responce.json());
  //     }
  //   } catch (err) {
  //     setLoading(false);
  //     toast.error(err.message);
  //   }
  //   setLoading(false);
  // }

  const exportBdcCr = async () => {
    setLoading(true);
    const request = {
      method: "POST",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "Origin, X-requested-With, Content-Type, Accept",
        'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        start_date: startDate
        , end_date: endDate
      })
    }
    try {
      var responce = await fetch(`https://lsreport.shls.care/api/bdc/extract/ca`, request, { mode: "cors" });
      if (responce.status === 200) {
        const blob = await responce.blob();
        const downloadLink = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        downloadLink.href = url;
        downloadLink.download = "BDC_par_chiffre_realise.xlsx";
        document.body.appendChild(downloadLink);
        downloadLink.click();

        document.body.removeChild(downloadLink);
        window.URL.revokeObjectURL(url);
        toast.success("success");

      } else {
        toast.error(await responce.json());
      }
    } catch (err) {
      setLoading(false);
      toast.error(err.message);
    }
    setLoading(false);
  }

  const exportBdcProduit = async () => {
    setLoading(true);
    const request = {
      method: "POST",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "Origin, X-requested-With, Content-Type, Accept",
        'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        start_date: startDate
        , end_date: endDate
      })
    }
    try {
      var responce = await fetch(`https://lsreport.shls.care/api/bdc/extract/product`, request, { mode: "cors" });
      if (responce.status === 200) {
        const blob = await responce.blob();
        const downloadLink = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        downloadLink.href = url;
        downloadLink.download = "BDC_par_produit.xlsx";
        document.body.appendChild(downloadLink);
        downloadLink.click();

        document.body.removeChild(downloadLink);
        window.URL.revokeObjectURL(url);
        toast.success("success");

      } else {
        toast.error(await responce.json());
      }
    } catch (err) {
      setLoading(false);
      toast.error(err.message);
    }
    setLoading(false);
  }

  const confirmDelete = (bdc_id) => {
    Swal.fire({
      title: "Voulez vous vraiment supprimer ce bon de commande?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Supprimer",
      denyButtonText: `Annuler`
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        deleteBdc(bdc_id)
      } else if (result.isDenied) {
        return
      }
    });
  }

  const deleteBdc = async (bdc_id) => {
    setLoading(true);
    const request = {
      method: "DELETE",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "Origin, X-requested-With, Content-Type, Accept",
        'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({ bdc_id })
    }
    try {
      var responce = await fetch("https://lsreport.shls.care/api/bdc/delete", request, { mode: "cors" });
      if (responce.status === 200) {
        toast.success("BDC supprimé avec succès");
        getBDC(
          {
            start_date: startDate
            , end_date: endDate
          }
        );
      } else {
        toast.error(await responce.json());
      }
    } catch (err) {
      setLoading(false);
      toast.error(err.message);
    }
    setLoading(false);
  }

  const filtredList = Array.isArray(data)
    ? searchKeyword
      ? data.filter((user) => {
        const firstName = user.user_firstname.toLowerCase() || "";
        const lastName = user.user_lastname.toLowerCase() || "";
        const grossiste = user.bdc_grossiste.toLowerCase() || "";
        return firstName.includes(searchKeyword.toLowerCase()) || lastName.includes(searchKeyword.toLowerCase()) || grossiste.includes(searchKeyword.toLowerCase());
      })
      : data
    : [];



  useEffect(() => {
    getBDC(
      {
        start_date: startDate
        , end_date: endDate
      }
    );
    window.scrollTo(0, 0);
  }, [])


  return (
    <Fragment>
      <Loader isLoading={isLoadingGet} />
      <Breadcrumbs parent="BDC" title="BDC" />

      <Container fluid={true}>
        <Row>
          <Col md={"2"} className='f'>
            <Form onSubmit={(e) => e.preventDefault()}>
              <FormGroup>
                <label htmlFor="">&#8203;</label>
                <Input
                  className="form-control"
                  type="text"
                  placeholder="Nom du grossiste ou visiteur"
                  value={searchKeyword}
                  style={{
                    border: "1px solid #000000",
                  }}
                  onChange={(e) => setSearchKeyword(e.target.value)}
                />
              </FormGroup>
            </Form>
          </Col>
          <Col md="2">
            <label htmlFor="">Du:</label>
            <DatePicker dateFormat={"dd/MM/yyyy"} selected={startDate} maxDate={new Date()} onChange={(date) => setStartDate(date)} />
          </Col>
          <Col md="2">
            <label htmlFor="">Au:</label>
            <DatePicker dateFormat={"dd/MM/yyyy"} minDate={startDate} maxDate={new Date()} selected={endDate} onChange={(date) => setEndDate(date)} />
          </Col>
          <Col md="2">
            <Button color='success' onClick={() => {
              getBDC({
                start_date: startDate
                , end_date: endDate
              })
            }} style={{ marginTop: "32px" }}>Rechercher</Button>
          </Col>
        </Row>
        <Row className='d-flex justify-content-end mb-2'>
          <button className='btn btn-success mr-2' onClick={() => { exportBdcCr() }}> Exporter par cr</button>
          <button className='btn btn-success mr-2' onClick={() => { exportBdcProduit() }}> Exporter par produit</button>
        </Row>

        {data.length === 0 ?
          <Card className='text-align-center'>
            <CardBody style={{ textAlign: "center" }}>
              <h4>Aucun BDC à afficher</h4>
            </CardBody>
          </Card>
          :
          <>
            <Row>
              <Col xs={12} className='o-auto'>
                <Table style={{ background: "white" }}>
                  <thead>
                    <tr className='text-center'>
                      <th>#</th>
                      <th>Code</th>
                      <th>Visiteur</th>
                      <th>Client</th>
                      <th>Pack</th>
                      <th>Grossiste</th>
                      <th>Wilaya</th>
                      <th>Commune</th>
                      <th>Total</th>
                      <th>Date</th>
                      <th>Statut</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(searchKeyword ? filtredList : data).map((bdc) => {
                      return (
                        <tr key={data.indexOf(bdc)} className='text-center'>
                          <th scope='row'> {(data.indexOf(bdc) + 1)}</th>
                          <td>{bdc.bdc_id}</td>
                          <td>{bdc.user_lastname} {bdc.user_firstname}</td>
                          <td>{bdc.contact_lastname} {bdc.contact_firstname}  </td>
                          <td>{bdc.bdc_pack}</td>
                          <td>{bdc.bdc_grossiste}</td>
                          <td>{bdc.contact_wilaya}</td>
                          <td>{bdc.contact_city}</td>
                          <td>{bdc.bdc_total + " DA"}</td>
                          <td>{moment(bdc.bdc_date).format("DD/MM/YYYY")}</td>
                          <td>
                            {
                              (() => {
                                if (bdc.bdc_status === "Annulé" || bdc.bdc_status === "annulé")
                                  return <span className="badge badge-pill badge-danger text-light p-2">{bdc.bdc_status}</span>
                                if (bdc.bdc_status === "honoré" || bdc.bdc_status === "Honoré")
                                  return <span className="badge badge-pill badge-success text-light p-2">{bdc.bdc_status.charAt(0).toUpperCase() + bdc.bdc_status.slice(1)}</span>
                                if (bdc.bdc_status === "Instance" || bdc.bdc_status === "instance")
                                  return <span className="badge badge-pill badge-primary text-light p-2">En {bdc.bdc_status}</span>
                                else
                                  return <span className="badge badge-pill badge-warning text-dark p-2">{bdc.bdc_status.charAt(0).toUpperCase() + bdc.bdc_status.slice(1)}</span>
                              })()
                            }
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <Link to={{
                              pathname: `/bdc/detailed`,
                            }} state={{ bdc: bdc }}>
                              <i className="fa fa-table mr-2" id="TooltipExample"></i>
                            </Link>
                            <i className="fa fa-file-excel-o mr-2 text-success " role="button" onClick={() => { exportDetails(bdc.bdc_id) }}></i>
                            <i className="fa fa-trash text-danger ml-2" id="TooltipExample" style={{ cursor: "pointer" }} onClick={() => confirmDelete(bdc.bdc_id)}></i>
                          </td>
                        </tr>
                      )
                    })
                    }
                  </tbody>
                </Table>
              </Col>
            </Row>

          </>
        }

      </Container>
    </Fragment>
  )
}
